/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-21 21:22:45
 * @LastEditors: zwh2 zwh2@meitu.com
 * @LastEditTime: 2025-05-22 10:29:40
 * @FilePath: /roboneo-web/src/common/next.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { ReactNode } from 'react';
import { createNextFunctions } from '@meitu/catalyze-next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Config } from './config';

/**
 * 不需要全局 `* { padding: 0; margin: 0 }` reset 的路由白名单。
 * ai_video 依赖 UA 默认间距与具体页面的 CSS Module 控制，
 * 全局通配 reset 会清掉 body / 列表 / 标题等默认 margin/padding，导致布局错位。
 */
const ROUTES_WITHOUT_GLOBAL_RESET = ['/ai_video'];

/**
 * 全局 Layout：除白名单路由外，注入一段 `* { padding:0; margin:0 }` reset。
 * 之所以放在 GlobalLayout 而非全局 CSS，是为了能按路由动态开关。
 */
function GlobalLayoutComponent({ children }: { children: ReactNode; }) {
  // 服务端首屏 router.pathname 仍然可用（Next 路由文件路径），不会出现首屏闪烁。
  // eslint-disable-next-line ban/ban
  const router = useRouter();
  const skipReset = ROUTES_WITHOUT_GLOBAL_RESET.some((p) => router.pathname.includes(p));
  return (
    <div className="GlobalLayout">
      {!skipReset && (
        <style>
          {'* { padding: 0; margin: 0; }'}
        </style>
      )}
      {children}
    </div>
  );
}

export const {
  defineNextApp,
  defineNextSubApp,
  defineNextPage,
  renderNextPage,
} = createNextFunctions<{
  ProjectId: Config['ProjectId'];
  LayoutId:
  'GlobalLayout'
  | 'MobileLayout'
  | 'RoboneoLayout'
  | 'OverseaLayout';
}>({
  layoutMap: {
    GlobalLayout: {
      component: GlobalLayoutComponent,
    },
    MobileLayout: {
      parent: 'GlobalLayout',
      component: dynamic(() => import('../pages/--mobile/MobileLayout')),
    },
    RoboneoLayout: {
      parent: 'GlobalLayout',
      component: dynamic(() => import('../pages/--roboneo/RoboneoLayout')),
    },
    OverseaLayout: {
      parent: 'GlobalLayout',
      component: dynamic(() => import('../pages/--oversea/layout')),
    },
  },
});
